/**
 *	config-prod.js
 */	
 
export default {
	appHostName: 'https://www.orange.ro',
    iframeParentHost: 'https://www.orange.ro',
    submitToken: 'Basic NTJkZWJnZTEybXMxbXMyMWswOTkya2FtczkybXNpMmE6MTJtZm9tc2tObXNrMjltc2xIblNrc3AyOTNtNTQ5MzAyVlQ='
};